import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AccessTokenService } from './access-token.service';
import { AlertService } from './alert.service';

export const userGuard: CanActivateFn = (route, state) => {
  const accessTokenService = inject(AccessTokenService);
  const router = inject(Router);
  const alertService = inject(AlertService);
  if (window.location.host == 'juliusbaer.spendkey.app' || window.location.host == 'dentsu.spendkey.app') {
    return true;
  } else if (accessTokenService.isUserMember()) {
    const loginErr_Mag = 'Access denied'
    router.navigateByUrl('dashboard');
    alertService.openAlert(loginErr_Mag, 'error');
    return false;
  }
  return true;
};
